import loadGoogleMapsApi from 'load-google-maps-api';

export default {
	async init() {
		const maps = document.querySelectorAll('.ga-map');
		if (!maps.length) return;
		const markers = await fetch('/destinations.json')
			.then(response => response.json())
			.then(response => response.data);
		if (markers.length) {
			loadGoogleMapsApi({ key: gaApiKey })
				.then((googleMaps) => {
					const bounds = new googleMaps.LatLngBounds();
					const map = new googleMaps.Map(document.querySelector('.ga-map'), {
						zoomControl: true,
						mapTypeControl: false,
						scaleControl: false,
						streetViewControl: false,
						rotateControl: false,
						fullscreenControl: false,
						zoom: 12,
					});

					markers.forEach((data) => {
						const infowindow = new google.maps.InfoWindow({
							content: `<div><h3 class="h5 text-primary">${data.title}</h3>${data.body}</div>`,
						});
						const marker = new googleMaps.Marker({
							title: data.title,
							position: data.location,
							map,
						});
						bounds.extend(marker.position);
						marker.addListener('click', () => {
							infowindow.open(map, marker);
						});
					});
					map.fitBounds(bounds);
				})
				.catch((error) => {
					console.error(error);
				});
		}
	},
};



// WEBPACK FOOTER //
// ./src/js/components/ga-maps.js